import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { Observable, firstValueFrom, of, EMPTY } from 'rxjs';
import { catchError, take } from 'rxjs/operators';

import { HttpErrorResponse } from '@angular/common/http';
import { ValidationPipe } from '../../core/pipes/validation.pipe';
import { map } from 'rxjs/operators';
import { AuthService } from 'libs/pnp-services/src/lib/auth/auth.service';
import { AuthErrors, AuthErrorService, PnpUserService } from '@pn-plus/pnp-services';
import { LoginService } from '../../core/services/login.service';

@Component({
    selector: 'nrwl-set-phone',
    templateUrl: './set-phone.component.html',
    styleUrls: ['./set-phone.component.scss'],
	providers: [ValidationPipe],
})
export class SetPhoneComponent implements OnInit {
    public activeError: any;
    public firstPhone = '';
    public secondPhone = '';
	public phoneForm: FormGroup;
    public isLoading = false;
    public lastValidNumber = '';
    public phoneMask = ['(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    public is2FA = false;

	constructor(
		private formBuilder: FormBuilder,
        private loginService: LoginService,
        private authService: AuthService,
        private pnpUserService: PnpUserService,
        private authErrorService: AuthErrorService,
	) {
	}

	ngOnInit(): void {

        const authModel = this.authService.getAuthModel();
        this.is2FA = !!authModel.loginResponse?.twoFactorToken;
        this.activeError = authModel?.error || AuthErrors.Success;

		this.phoneForm = this.formBuilder.group(
			{
				phone: ['', [ Validators.required ] ],
			},
		);
	}

    async onPhoneChanged($event: any) {
        const phone = this.phoneForm.value.phone.replace(/\D/g, '');

        if(phone.length < 10 || this.lastValidNumber === phone) {
            return;
        }

        this.setBusy(true);
        
        if($event.preventDefault || $event.stopPropagation) {
            $event.preventDefault();
            $event.stopPropagation();
        }

        this.activeError = AuthErrors.Success;
        this.lastValidNumber = phone;

        await firstValueFrom(this.putUserPhoneNumber(phone));
        await firstValueFrom(this.putHasPhoneNumber());

        if(!this.activeError) {
            const isInvitationProcess = this.authService.getIsInvitationProcess();
            if (isInvitationProcess) {
                this.loginService.navigate('/verify-recovery-phone');
            } else {
                this.loginService.navigateRegistration(this.authService.authModel);
            }
        }
        this.setBusy(false);
    }

    // updateRegistration(tokenResponse: any, hasPhoneNumber: boolean) {
    //     const authModel = this.authService.authModel;
    //     if(tokenResponse) {
    //         authModel.phoneNumberResponse = tokenResponse;
    //         if(authModel.userResponse) {
    //             authModel.userResponse.phoneNumber = this.phoneForm.value.phone;
    //         }
    //     }
    //     if(hasPhoneNumber && authModel.registrationResponse) {
    //         authModel.registrationResponse.hasPhoneNumber = true;
    //     }
    //     this.authService.authModel = authModel;
    //     return authModel;
    // }

    putUserPhoneNumber(phone: string) {
        return this.pnpUserService.putUserPhoneNumber(phone)
            .pipe(
                catchError((errorResponse: HttpErrorResponse) => {
                    this.activeError = this.authErrorService.getErrorByType(errorResponse.error.type);
                    return of(null);
                }),
                map((phoneNumberResponse) => {
                    if(phoneNumberResponse?.jwt) {
                        const authModel = this.authService.authModel;
                        authModel.phoneNumberResponse = phoneNumberResponse;
                        if(authModel.userResponse) {
                            authModel.userResponse.phoneNumber = phone;
                        }
                        this.authService.updateAuthModel(authModel);
                    }
                    return phoneNumberResponse;
                })
            );
    }

    putHasPhoneNumber(): Observable<any> {
        if(this.activeError) {
            return of(null);
        }
        return this.pnpUserService.putHasPhoneNumber()
            .pipe(
                catchError((errorResponse: HttpErrorResponse) => {
                    this.activeError = this.authErrorService.getErrorByType(errorResponse.error.type);
                    return of(null);
                }),
                map((response) => {
                    if(!this.activeError) {
                        const authModel = this.authService.authModel;
                        if(authModel?.registrationResponse) {
                            authModel.registrationResponse.hasPhoneNumber = true;
                        }
                        this.authService.updateAuthModel(authModel);
                    }
                    return response;
                }),
            );
    }

    public onSkipThisStepClicked(): void {
        this.loginService.navigate('/set-avatar');
    }

    setBusy(flag: boolean): void {
        this.isLoading = flag;
    }

    goToPrivacy() 
    {
        window.open('http://www.patientnow.com/privacy-policy/', '_blank');
    }

    gotoTermsOfService() 
    {
        window.open('https://www.patientnow.com/terms-of-service/', '_blank');
    }
}
